// extracted by mini-css-extract-plugin
module.exports = {"breakpointDesktop":"1024px","picture":"Tourist_picture__FhLQf"};